import dayjs from 'dayjs';

export const WIDGET_TYPES = {
	bar: 'bar',
	column: 'column',
	line: 'line',
	pie: 'pie',
	table: 'table',
	cards: 'cards'
};

export const WIDGET_SIZES = {
	small: 'small',
	medium: 'medium',
	large: 'large'
};

export const WIDGET_VERSION = '_new2';

export const ANALYSIS_PAGES = {
	dashboard: 'dashboard',
	overview: 'analysis.overview',
	SLAPerformance: 'analysisSLA',
	deliveryCompany: 'analysisCarrierPerformance',
	shippingAccounting: 'analysisShippingAccounting',
	sales: 'sales',
	otoFlex: 'otoFlexAnalysis'
};

export const calcultateCustomWidgetDateFilter = (defaultFilters) => {
	if (defaultFilters?.from && defaultFilters?.to) {
		const start = dayjs(defaultFilters?.from);
		const end = dayjs(defaultFilters?.to);
		const diff = end.diff(start, 'day');

		let defaultDay = 'customDateRange';

		if (diff === 1 && end.isSame(dayjs(), 'day')) {
			defaultDay = 'today';
		} else if (diff === 13 && end.isSame(dayjs(), 'day')) {
			defaultDay = 'last14Days';
		} else if (diff === 6 && end.isSame(dayjs(), 'day')) {
			defaultDay = 'last7Days';
		} else if (diff === 29 && end.isSame(dayjs(), 'day')) {
			defaultDay = 'last30Days';
		}

		return defaultDay === 'customDateRange'
			? { defaultDay, defaultFilter: { start: defaultFilters?.from, end: defaultFilters?.to } }
			: { defaultDay };
	} else {
		return null;
	}
};
